
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Perfil from "../pages/perfil/page";
import Mentoria from "../pages/mentoria/page";
import Gamificacao from "../pages/gamificacao/page";
import Sustentabilidade from "../pages/sustentabilidade/page";
import Relatorios from "../pages/relatorios/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/perfil",
    element: <Perfil />,
  },
  {
    path: "/mentoria",
    element: <Mentoria />,
  },
  {
    path: "/gamificacao",
    element: <Gamificacao />,
  },
  {
    path: "/sustentabilidade",
    element: <Sustentabilidade />,
  },
  {
    path: "/relatorios",
    element: <Relatorios />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
